var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 1.83008C18.344 1.83008 20.0416 3.52767 20.0416 5.62175C20.0416 7.71582 18.344 9.41341 16.25 9.41341M22.2083 20.2467H23.8333C24.4316 20.2467 24.9257 19.7583 24.8296 19.1678C24.3885 16.4582 22.3106 14.2101 19.4999 13.2146M9.74995 9.41341C7.65587 9.41341 5.95828 7.71582 5.95828 5.62174C5.95828 3.52767 7.65587 1.83008 9.74995 1.83008C11.844 1.83008 13.5416 3.52767 13.5416 5.62175C13.5416 7.71582 11.844 9.41341 9.74995 9.41341ZM1.17035 19.1677C1.76898 15.4906 5.38213 12.6634 9.74995 12.6634C14.1178 12.6634 17.7309 15.4906 18.3296 19.1677C18.4257 19.7583 17.9316 20.2467 17.3333 20.2467H2.16662C1.56831 20.2467 1.07421 19.7583 1.17035 19.1677Z",
    stroke: "#171717",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerMenu);
export default __webpack_public_path__ + "static/media/customer-menu.c98f4c8959a06b900ec4203acd2cdd2d.svg";
export { ForwardRef as ReactComponent };